import { render, staticRenderFns } from "./PaginatedSearchResultList.vue?vue&type=template&id=5bd4c0db"
import script from "./PaginatedSearchResultList.vue?vue&type=script&lang=ts"
export * from "./PaginatedSearchResultList.vue?vue&type=script&lang=ts"
import style0 from "./PaginatedSearchResultList.vue?vue&type=style&index=0&id=5bd4c0db&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports